import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HorizontalTab } from '../../event-list/components';
import { TAB_ROUTES, TABS } from './constants';
import './style';

const AdminListing = ({ children }) => {
  const [selectedTab, setSelectedTab] = useState('Events');
  const navigate = useNavigate();
  const location = useLocation();

  const onSelectTab = (value) => {
    navigate(TAB_ROUTES[value]);
    setSelectedTab(value);
  };

  useEffect(() => {
    const idx = Object.values(TAB_ROUTES).findIndex((tabRoute) => tabRoute === location.pathname);

    if (idx > -1 && Object.keys(TAB_ROUTES)[idx] !== selectedTab) setSelectedTab(Object.keys(TAB_ROUTES)[idx]);
  }, [location?.pathname]);


  return (
    <div className="flex flex-col admin-layout mt-[120px]">
      <HorizontalTab
        tabs={TABS}
        className="admin-panel-tab"
        onSelect={onSelectTab}
        selectedTab={selectedTab}
      />
      {children}
    </div>
  );
};

export default AdminListing;
